import { render, staticRenderFns } from "./CtrlTecnicoPage.vue?vue&type=template&id=705f04d5"
import script from "./CtrlTecnicoPage.vue?vue&type=script&lang=js"
export * from "./CtrlTecnicoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports